import { Vue, Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { CountryCondition, CountryNote } from '@ve/types';
import getNotesByCountries from './service/getNotesByCountries';

@Component({
    name: 'CountryConditions',
    computed: {
        ...mapState('mapForCountryConditions', [
            'countries',
        ]),
        ...mapState('countryConditions', [
            'countryConditions',
        ]),
    },
})
export default class CountryConditionsMixin extends Vue {
    @Prop(Boolean) readonly isHotTours?: boolean;

    private countries!: number[];

    private countryConditions!: CountryCondition[];

    get countryNotes(): CountryNote[] {
        return getNotesByCountries({
            countries: this.countries,
            countryConditions: this.countryConditions,
        });
    }

    get viewBanner(): boolean {
        const idCurrentCountry = this.countries[0];
        const avalibleCountries = [68, 92];

        if (avalibleCountries.includes(idCurrentCountry) && !this.isHotTours) {
            return false;
        }
        return true;
    }
}